// Each ChopBox tool page's icon: the same as its button in the ChopBox rail
// (components/chopbox/ui/state/tools.ts), so the page cards, the landing
// page's tool buttons and the editor all show one picture per tool.

import { Bandage, Camera, Clapperboard, Eraser, Film, Focus, Layers, LayoutGrid, ScanFace, Type, Wallpaper, WandSparkles, type LucideIcon } from "lucide-react";
import { EDITOR_PAGE_KEYS, type EditorPageKey } from "./routes";

export const PAGE_ICONS: Record<EditorPageKey, LucideIcon> = {
  hub: LayoutGrid,
  animatePhoto: Clapperboard,
  takePhoto: Camera,
  removeBackground: Wallpaper,
  eraseBackground: Eraser,
  blurBackground: Focus,
  greenScreen: Layers,
  trimVideo: Film,
  faceRetouch: ScanFace,
  addText: Type,
  removeSpots: Bandage,
  photoFilters: WandSparkles,
};

/** Every tool page (not the hub), in the order the pages list them. */
export const TOOL_PAGE_KEYS: EditorPageKey[] = EDITOR_PAGE_KEYS.filter((key) => key !== "hub");
